














import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as XLSX from "xlsx";
import ExcelImporter from '@/components/Importer/ExcelImporter.vue';
import SheetSelect from '@/components/Importer/SheetSelect.vue';
import SheetPreview from '@/components/Importer/SheetPreview.vue';
import SheetHelper from './models/SheetHelper';

@Component({
  components: {
    ExcelImporter,
    SheetSelect,
    SheetPreview,
  },
})
export default class FileSelectionStep extends Vue {
  private static readonly JSON_CONVERT_OPTIONS: XLSX.Sheet2JSONOpts = { raw: false, header: 'A', defval: '-' };

  file: XLSX.WorkBook | null = null;
  selectedSheet: XLSX.WorkSheet | null = null;
  selectedSheetName: string = '';
  
  get rows() {
    return this.$store.state.importer.rowData;
  }

  set rows(rowData: any[]) {
    this.$store.commit('importer/setRowData', rowData);
  }
  
  get showSheetSelect() {
    if (this.file && this.file.SheetNames.length > 1) {
      return true;
    }
    return false;
  }
  
  uploadFile(file: XLSX.WorkBook) {
    this.file = file;
    const firstSheetName = this.file.SheetNames.find(sn => sn);
    this.selectSheet(firstSheetName);
  }

  selectSheet(sheetName: string) {
    if (!sheetName) {
      this.selectedSheet = null;
      this.selectedSheetName = '';
      return;
    }
    this.selectedSheet = this.file.Sheets[sheetName];
    this.selectedSheetName = sheetName;
    this.rows = this.getSheetAsJsonRows(this.selectedSheet);
  }

  getSheetAsJsonRows(sheet: XLSX.WorkSheet) {
    if (!sheet) {
      return [];
    }
    const json = SheetHelper.getSheetAsJson(sheet);
    // json.shift();
    return json;
  }

  clearFile() {
    this.file = null;
    this.selectedSheet = null;
  }
}
